// Close menu when clicking anchor links (mobile and desktop)
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu
  const menuSidebar = document.getElementById('site-menu-sidebar');
  
  if (menuSidebar) {
    menuSidebar.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      
      // Only close if it's an anchor link
      if (link && link.getAttribute('href')) {
        const href = link.getAttribute('href');
        
        // Check if it's an anchor link (contains #) but NOT just "#"
        if (href.includes('#') && href !== '#' && href !== 'javascript:void(0)') {
// Check if this link opens another submenu (has aria-controls)
const opensSubmenu = link.hasAttribute('aria-controls');

// Only close if it's NOT opening a submenu
if (!opensSubmenu) {
            setTimeout(function() {
              const closeButton = menuSidebar.querySelector('[data-js-close]');
              if (closeButton) {
                closeButton.click();
              }
            }, 100);
          }
        }
      }
    });
  }
  
  // Cart drawer - close when clicking anchor links
  const cartSidebar = document.getElementById('site-cart-sidebar');
  
  if (cartSidebar) {
    cartSidebar.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      
      // Only close if it's an anchor link
      if (link && link.getAttribute('href')) {
        const href = link.getAttribute('href');
        
        // Check if it's an anchor link (contains #) but NOT just "#"
        if (href.includes('#') && href !== '#' && href !== 'javascript:void(0)') {
          setTimeout(function() {
            const closeButton = cartSidebar.querySelector('[data-js-close]');
            if (closeButton) {
              closeButton.click();
            }
          }, 100);
        }
      }
    });
  }
  
  // Desktop menu - close any open dropdowns
  const desktopMenu = document.querySelector('.header__bottom .header-links');
  
  if (desktopMenu) {
    desktopMenu.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      
      if (link && link.getAttribute('href')) {
        const href = link.getAttribute('href');
        
        if (href.includes('#') && href !== '#' && href !== 'javascript:void(0)') {
          // Close any open submenus
          const openMenus = document.querySelectorAll('.site-nav__item.is-active');
          openMenus.forEach(function(menu) {
            menu.classList.remove('is-active');
          });
        }
      }
    });
  }
});

